import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { requestCompanyWebsite } from '../../types';

type initialStateType = {
    is_loading_company_websites?: boolean;
    company_websites_request?: Array<requestCompanyWebsite>;
    is_updating_company_website_request?: boolean;
    is_adding_company_website_request?: boolean;
    is_deleting_company_website_request?: boolean;
};

const initialState: initialStateType = {
    is_loading_company_websites: false,
    company_websites_request: [],
    is_updating_company_website_request: false,
    is_adding_company_website_request: false,
    is_deleting_company_website_request: false,
};

const companyWebsiteRequestSlice = createSlice({
    name: 'companyWebsiteRequest',
    initialState,
    reducers: {
        setCompanyWebsiteRequests: (state, action: PayloadAction<Array<requestCompanyWebsite>>) => {
            return {
                ...state,
                company_websites_request: action.payload,
            };
        },
        onCompanyWebsiteRequestsUpdate: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_updating_company_website_request: action.payload,
            };
        },
        onAddingCompanyWebsiteRequests: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_adding_company_website_request: action.payload,
            };
        },
        onDeleteCompanyWebsiteRequests: (state, action: PayloadAction<boolean>) => {
            return {
                ...state,
                is_deleting_company_website_request: action.payload,
            };
        },
    }
});

export const { setCompanyWebsiteRequests, onCompanyWebsiteRequestsUpdate, onAddingCompanyWebsiteRequests, onDeleteCompanyWebsiteRequests } = companyWebsiteRequestSlice.actions;

export default companyWebsiteRequestSlice.reducer;